import React from 'react'
import { AppHOC, AppProps, AppWithSessionHOC, AppWithSessionProps } from './AppHOC'

const CtaContainer = React.lazy(() => import('@components/CTA/CtaContainer'))

export const CtaApp: React.FC<AppWithSessionProps> = props => {
  const { session, actionModule, environment } = props
  return (
    <AppWithSessionHOC session={session} environment={environment} actionModule={actionModule}>
      <CtaContainer />
    </AppWithSessionHOC>
  )
}
